// Ant interface
import { UploadFile } from "antd/es/upload/interface";

// Utils
import { generateZipFile } from "utils/generateZipFile";

export type FunctionProps = {
	fileList: UploadFile<any>[];
	retro_Claim_id: number;
	remarks: string;
};

export const getFormData = async ({ fileList, retro_Claim_id, remarks }: FunctionProps) => {
	const formData = new FormData();
	formData.append("retro_claim_id", retro_Claim_id.toString());
	formData.append("remarks", remarks);
	formData.append("files", await generateZipFile(fileList));

	return formData;
};
